export default __webpack_public_path__ + "static/Martini Triangle Top-7a8ac6bd571e560b664fa6bbef00d90c.webp";